// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/fraud.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.ClickLabel
 */
export enum ClickLabel {
  /**
   * @generated from enum value: CLICK_LABEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLICK_LABEL_HUMAN = 1;
   */
  HUMAN = 1,

  /**
   * @generated from enum value: CLICK_LABEL_BOT = 2;
   */
  BOT = 2,

  /**
   * @generated from enum value: CLICK_LABEL_FRAUD = 3;
   */
  FRAUD = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(ClickLabel)
proto3.util.setEnumType(ClickLabel, "tracker.v1.ClickLabel", [
  { no: 0, name: "CLICK_LABEL_UNSPECIFIED" },
  { no: 1, name: "CLICK_LABEL_HUMAN" },
  { no: 2, name: "CLICK_LABEL_BOT" },
  { no: 3, name: "CLICK_LABEL_FRAUD" },
]);

/**
 * @generated from message tracker.v1.LabelClickRequest
 */
export class LabelClickRequest extends Message<LabelClickRequest> {
  /**
   * @generated from field: string click_id = 1;
   */
  clickId = "";

  /**
   * @generated from field: tracker.v1.ClickLabel label = 2;
   */
  label = ClickLabel.UNSPECIFIED;

  /**
   * @generated from field: string note = 3;
   */
  note = "";

  constructor(data?: PartialMessage<LabelClickRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LabelClickRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "click_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "enum", T: proto3.getEnumType(ClickLabel) },
    { no: 3, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LabelClickRequest {
    return new LabelClickRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LabelClickRequest {
    return new LabelClickRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LabelClickRequest {
    return new LabelClickRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LabelClickRequest | PlainMessage<LabelClickRequest> | undefined, b: LabelClickRequest | PlainMessage<LabelClickRequest> | undefined): boolean {
    return proto3.util.equals(LabelClickRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.LabelClickResponse
 */
export class LabelClickResponse extends Message<LabelClickResponse> {
  constructor(data?: PartialMessage<LabelClickResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.LabelClickResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LabelClickResponse {
    return new LabelClickResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LabelClickResponse {
    return new LabelClickResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LabelClickResponse {
    return new LabelClickResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LabelClickResponse | PlainMessage<LabelClickResponse> | undefined, b: LabelClickResponse | PlainMessage<LabelClickResponse> | undefined): boolean {
    return proto3.util.equals(LabelClickResponse, a, b);
  }
}

/**
 * ClassificationCount is the event volume + average score for one verdict
 * bucket over the window.
 *
 * @generated from message tracker.v1.ClassificationCount
 */
export class ClassificationCount extends Message<ClassificationCount> {
  /**
   * @generated from field: string classification = 1;
   */
  classification = "";

  /**
   * @generated from field: uint64 events = 2;
   */
  events = protoInt64.zero;

  /**
   * @generated from field: double avg_score = 3;
   */
  avgScore = 0;

  constructor(data?: PartialMessage<ClassificationCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ClassificationCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "classification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "events", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "avg_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClassificationCount {
    return new ClassificationCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClassificationCount {
    return new ClassificationCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClassificationCount {
    return new ClassificationCount().fromJsonString(jsonString, options);
  }

  static equals(a: ClassificationCount | PlainMessage<ClassificationCount> | undefined, b: ClassificationCount | PlainMessage<ClassificationCount> | undefined): boolean {
    return proto3.util.equals(ClassificationCount, a, b);
  }
}

/**
 * DimensionCount is bot vs total events for one facet value (proxy type,
 * country, asn type).
 *
 * @generated from message tracker.v1.DimensionCount
 */
export class DimensionCount extends Message<DimensionCount> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: uint64 events = 2;
   */
  events = protoInt64.zero;

  /**
   * @generated from field: uint64 bot_events = 3;
   */
  botEvents = protoInt64.zero;

  constructor(data?: PartialMessage<DimensionCount>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DimensionCount";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "events", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "bot_events", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DimensionCount {
    return new DimensionCount().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DimensionCount {
    return new DimensionCount().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DimensionCount {
    return new DimensionCount().fromJsonString(jsonString, options);
  }

  static equals(a: DimensionCount | PlainMessage<DimensionCount> | undefined, b: DimensionCount | PlainMessage<DimensionCount> | undefined): boolean {
    return proto3.util.equals(DimensionCount, a, b);
  }
}

/**
 * ScoreBucket is one bar of the 0..100 score histogram (bucket * 10).
 *
 * @generated from message tracker.v1.ScoreBucket
 */
export class ScoreBucket extends Message<ScoreBucket> {
  /**
   * @generated from field: uint32 bucket = 1;
   */
  bucket = 0;

  /**
   * @generated from field: uint64 events = 2;
   */
  events = protoInt64.zero;

  constructor(data?: PartialMessage<ScoreBucket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ScoreBucket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bucket", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "events", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScoreBucket {
    return new ScoreBucket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScoreBucket {
    return new ScoreBucket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScoreBucket {
    return new ScoreBucket().fromJsonString(jsonString, options);
  }

  static equals(a: ScoreBucket | PlainMessage<ScoreBucket> | undefined, b: ScoreBucket | PlainMessage<ScoreBucket> | undefined): boolean {
    return proto3.util.equals(ScoreBucket, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFraudOverviewRequest
 */
export class GetFraudOverviewRequest extends Message<GetFraudOverviewRequest> {
  /**
   * @generated from field: tracker.v1.DateRange range = 1;
   */
  range?: DateRange;

  /**
   * @generated from field: string campaign_id = 2;
   */
  campaignId = "";

  constructor(data?: PartialMessage<GetFraudOverviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFraudOverviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "range", kind: "message", T: DateRange },
    { no: 2, name: "campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFraudOverviewRequest {
    return new GetFraudOverviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFraudOverviewRequest {
    return new GetFraudOverviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFraudOverviewRequest {
    return new GetFraudOverviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFraudOverviewRequest | PlainMessage<GetFraudOverviewRequest> | undefined, b: GetFraudOverviewRequest | PlainMessage<GetFraudOverviewRequest> | undefined): boolean {
    return proto3.util.equals(GetFraudOverviewRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFraudOverviewResponse
 */
export class GetFraudOverviewResponse extends Message<GetFraudOverviewResponse> {
  /**
   * @generated from field: repeated tracker.v1.ClassificationCount by_classification = 1;
   */
  byClassification: ClassificationCount[] = [];

  /**
   * @generated from field: repeated tracker.v1.ScoreBucket score_histogram = 2;
   */
  scoreHistogram: ScoreBucket[] = [];

  /**
   * @generated from field: repeated tracker.v1.DimensionCount top_proxy_types = 3;
   */
  topProxyTypes: DimensionCount[] = [];

  /**
   * @generated from field: repeated tracker.v1.DimensionCount top_countries = 4;
   */
  topCountries: DimensionCount[] = [];

  /**
   * @generated from field: uint64 total_events = 5;
   */
  totalEvents = protoInt64.zero;

  /**
   * (bot + suspicious) / total
   *
   * @generated from field: double bot_rate = 6;
   */
  botRate = 0;

  /**
   * Historical detector observations do not cover all traffic in this range.
   *
   * @generated from field: bool partial = 7;
   */
  partial = false;

  /**
   * Stable backend capability/status code, not a frontend environment guess.
   *
   * @generated from field: string coverage_reason = 8;
   */
  coverageReason = "";

  /**
   * Latest observed UTC day within the requested range; empty means unknown.
   * This is the observation day, not the time this response was generated.
   *
   * @generated from field: string latest_observation_date = 9;
   */
  latestObservationDate = "";

  constructor(data?: PartialMessage<GetFraudOverviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFraudOverviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "by_classification", kind: "message", T: ClassificationCount, repeated: true },
    { no: 2, name: "score_histogram", kind: "message", T: ScoreBucket, repeated: true },
    { no: 3, name: "top_proxy_types", kind: "message", T: DimensionCount, repeated: true },
    { no: 4, name: "top_countries", kind: "message", T: DimensionCount, repeated: true },
    { no: 5, name: "total_events", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "bot_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "partial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "coverage_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "latest_observation_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFraudOverviewResponse {
    return new GetFraudOverviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFraudOverviewResponse {
    return new GetFraudOverviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFraudOverviewResponse {
    return new GetFraudOverviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFraudOverviewResponse | PlainMessage<GetFraudOverviewResponse> | undefined, b: GetFraudOverviewResponse | PlainMessage<GetFraudOverviewResponse> | undefined): boolean {
    return proto3.util.equals(GetFraudOverviewResponse, a, b);
  }
}

/**
 * ScoringSignal is one entry in the scoring catalog. The three inactive states
 * are distinct and all three are surfaced: `disabled` is switched off,
 * `shadow` is evaluated and traced but contributes 0 (how a new signal earns
 * its weight against real traffic), and `unavailable` means the input does not
 * exist on this deployment — NOT that it was checked and found clean.
 *
 * @generated from message tracker.v1.ScoringSignal
 */
export class ScoringSignal extends Message<ScoringSignal> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Points a fired signal adds. May be NEGATIVE: some facts are evidence of a
   * human, and a scorer with no way to say so can only accumulate suspicion.
   *
   * @generated from field: double weight = 2;
   */
  weight = 0;

  /**
   * Saturation point of a graded signal — the observed value at which it
   * contributes its full weight. Ignored by boolean signals.
   *
   * @generated from field: double norm = 3;
   */
  norm = 0;

  /**
   * @generated from field: bool shadow = 4;
   */
  shadow = false;

  /**
   * @generated from field: bool disabled = 5;
   */
  disabled = false;

  /**
   * @generated from field: bool unavailable = 6;
   */
  unavailable = false;

  /**
   * Why an unavailable signal cannot be observed, for the UI. Empty otherwise.
   *
   * @generated from field: string reason = 7;
   */
  reason = "";

  /**
   * How often this signal is right when it fires, as far as we know. It does
   * not affect the score — a signal we half-trust earns a smaller weight.
   *
   * @generated from field: double confidence = 8;
   */
  confidence = 0;

  constructor(data?: PartialMessage<ScoringSignal>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ScoringSignal";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "norm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "shadow", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScoringSignal {
    return new ScoringSignal().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScoringSignal {
    return new ScoringSignal().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScoringSignal {
    return new ScoringSignal().fromJsonString(jsonString, options);
  }

  static equals(a: ScoringSignal | PlainMessage<ScoringSignal> | undefined, b: ScoringSignal | PlainMessage<ScoringSignal> | undefined): boolean {
    return proto3.util.equals(ScoringSignal, a, b);
  }
}

/**
 * ScoringCatalog is the versioned rule set: the signals, their weights, and the
 * thresholds their sum is bucketed by. It replaces the flat map<string,double>,
 * which could carry a number per signal and nothing else — no shadow, no
 * deprecation, no availability, and no version, which is why ruleset_version
 * was a column nothing could fill.
 *
 * @generated from message tracker.v1.ScoringCatalog
 */
export class ScoringCatalog extends Message<ScoringCatalog> {
  /**
   * @generated from field: uint32 version = 1;
   */
  version = 0;

  /**
   * @generated from field: repeated tracker.v1.ScoringSignal signals = 2;
   */
  signals: ScoringSignal[] = [];

  /**
   * @generated from field: double suspicious_at = 3;
   */
  suspiciousAt = 0;

  /**
   * @generated from field: double bot_at = 4;
   */
  botAt = 0;

  /**
   * Deterministic fingerprint of the scoring behaviour (version, weights, and
   * the flags that decide whether a signal counts). Two deployments reporting
   * the same hash scored traffic by identical rules. Read-only: set by the
   * server, ignored on write.
   *
   * @generated from field: string hash = 5;
   */
  hash = "";

  constructor(data?: PartialMessage<ScoringCatalog>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ScoringCatalog";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "signals", kind: "message", T: ScoringSignal, repeated: true },
    { no: 3, name: "suspicious_at", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "bot_at", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ScoringCatalog {
    return new ScoringCatalog().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ScoringCatalog {
    return new ScoringCatalog().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ScoringCatalog {
    return new ScoringCatalog().fromJsonString(jsonString, options);
  }

  static equals(a: ScoringCatalog | PlainMessage<ScoringCatalog> | undefined, b: ScoringCatalog | PlainMessage<ScoringCatalog> | undefined): boolean {
    return proto3.util.equals(ScoringCatalog, a, b);
  }
}

/**
 * ProposedWeightSet is one feedback-loop tuning proposal awaiting approval.
 *
 * @generated from message tracker.v1.ProposedWeightSet
 */
export class ProposedWeightSet extends Message<ProposedWeightSet> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * empty = global
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string note = 3;
   */
  note = "";

  /**
   * @generated from field: string created_by = 4;
   */
  createdBy = "";

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt = "";

  /**
   * @generated from field: tracker.v1.ScoringCatalog catalog = 6;
   */
  catalog?: ScoringCatalog;

  constructor(data?: PartialMessage<ProposedWeightSet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ProposedWeightSet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "catalog", kind: "message", T: ScoringCatalog },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProposedWeightSet {
    return new ProposedWeightSet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProposedWeightSet {
    return new ProposedWeightSet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProposedWeightSet {
    return new ProposedWeightSet().fromJsonString(jsonString, options);
  }

  static equals(a: ProposedWeightSet | PlainMessage<ProposedWeightSet> | undefined, b: ProposedWeightSet | PlainMessage<ProposedWeightSet> | undefined): boolean {
    return proto3.util.equals(ProposedWeightSet, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListProposedWeightsRequest
 */
export class ListProposedWeightsRequest extends Message<ListProposedWeightsRequest> {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId = "";

  constructor(data?: PartialMessage<ListProposedWeightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListProposedWeightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProposedWeightsRequest {
    return new ListProposedWeightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProposedWeightsRequest {
    return new ListProposedWeightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProposedWeightsRequest {
    return new ListProposedWeightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListProposedWeightsRequest | PlainMessage<ListProposedWeightsRequest> | undefined, b: ListProposedWeightsRequest | PlainMessage<ListProposedWeightsRequest> | undefined): boolean {
    return proto3.util.equals(ListProposedWeightsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListProposedWeightsResponse
 */
export class ListProposedWeightsResponse extends Message<ListProposedWeightsResponse> {
  /**
   * @generated from field: repeated tracker.v1.ProposedWeightSet items = 1;
   */
  items: ProposedWeightSet[] = [];

  constructor(data?: PartialMessage<ListProposedWeightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListProposedWeightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: ProposedWeightSet, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListProposedWeightsResponse {
    return new ListProposedWeightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListProposedWeightsResponse {
    return new ListProposedWeightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListProposedWeightsResponse {
    return new ListProposedWeightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListProposedWeightsResponse | PlainMessage<ListProposedWeightsResponse> | undefined, b: ListProposedWeightsResponse | PlainMessage<ListProposedWeightsResponse> | undefined): boolean {
    return proto3.util.equals(ListProposedWeightsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ActivateWeightsRequest
 */
export class ActivateWeightsRequest extends Message<ActivateWeightsRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ActivateWeightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActivateWeightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateWeightsRequest {
    return new ActivateWeightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateWeightsRequest {
    return new ActivateWeightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateWeightsRequest {
    return new ActivateWeightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateWeightsRequest | PlainMessage<ActivateWeightsRequest> | undefined, b: ActivateWeightsRequest | PlainMessage<ActivateWeightsRequest> | undefined): boolean {
    return proto3.util.equals(ActivateWeightsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ActivateWeightsResponse
 */
export class ActivateWeightsResponse extends Message<ActivateWeightsResponse> {
  constructor(data?: PartialMessage<ActivateWeightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActivateWeightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActivateWeightsResponse {
    return new ActivateWeightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActivateWeightsResponse {
    return new ActivateWeightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActivateWeightsResponse {
    return new ActivateWeightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ActivateWeightsResponse | PlainMessage<ActivateWeightsResponse> | undefined, b: ActivateWeightsResponse | PlainMessage<ActivateWeightsResponse> | undefined): boolean {
    return proto3.util.equals(ActivateWeightsResponse, a, b);
  }
}

/**
 * ActiveWeightSet is the live bot-scoring weight set for one scope, plus the
 * provenance of how it became active (default fallback, feedback-loop tuned, or
 * a manual admin edit).
 *
 * @generated from message tracker.v1.ActiveWeightSet
 */
export class ActiveWeightSet extends Message<ActiveWeightSet> {
  /**
   * @generated from field: tracker.v1.ScoringCatalog catalog = 1;
   */
  catalog?: ScoringCatalog;

  /**
   * origin is "default" (shipped baseline — no row), "manual" (admin-edited),
   * or "feedback" (a feedback-loop proposal that was activated).
   *
   * @generated from field: string origin = 2;
   */
  origin = "";

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy = "";

  /**
   * @generated from field: string updated_at = 4;
   */
  updatedAt = "";

  constructor(data?: PartialMessage<ActiveWeightSet>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActiveWeightSet";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "catalog", kind: "message", T: ScoringCatalog },
    { no: 2, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActiveWeightSet {
    return new ActiveWeightSet().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActiveWeightSet {
    return new ActiveWeightSet().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActiveWeightSet {
    return new ActiveWeightSet().fromJsonString(jsonString, options);
  }

  static equals(a: ActiveWeightSet | PlainMessage<ActiveWeightSet> | undefined, b: ActiveWeightSet | PlainMessage<ActiveWeightSet> | undefined): boolean {
    return proto3.util.equals(ActiveWeightSet, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetActiveWeightsRequest
 */
export class GetActiveWeightsRequest extends Message<GetActiveWeightsRequest> {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId = "";

  constructor(data?: PartialMessage<GetActiveWeightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetActiveWeightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveWeightsRequest {
    return new GetActiveWeightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveWeightsRequest {
    return new GetActiveWeightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveWeightsRequest {
    return new GetActiveWeightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveWeightsRequest | PlainMessage<GetActiveWeightsRequest> | undefined, b: GetActiveWeightsRequest | PlainMessage<GetActiveWeightsRequest> | undefined): boolean {
    return proto3.util.equals(GetActiveWeightsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetActiveWeightsResponse
 */
export class GetActiveWeightsResponse extends Message<GetActiveWeightsResponse> {
  /**
   * active is the effective set for the requested scope (the per-workspace
   * override when one exists, else the global active set, else defaults).
   *
   * @generated from field: tracker.v1.ActiveWeightSet active = 1;
   */
  active?: ActiveWeightSet;

  /**
   * defaults is the shipped DefaultCatalog baseline — the "reset" target and
   * the source of the full signal set the editor renders.
   *
   * @generated from field: tracker.v1.ScoringCatalog defaults = 2;
   */
  defaults?: ScoringCatalog;

  /**
   * is_workspace_override is true when `active` is a per-workspace row rather
   * than the inherited global set.
   *
   * @generated from field: bool is_workspace_override = 3;
   */
  isWorkspaceOverride = false;

  /**
   * scope is the set the caller is editing: "global" (platform-admin tuning the
   * shared default) or "workspace" (a tenant admin tuning their own workspace).
   *
   * @generated from field: string scope = 4;
   */
  scope = "";

  constructor(data?: PartialMessage<GetActiveWeightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetActiveWeightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "active", kind: "message", T: ActiveWeightSet },
    { no: 2, name: "defaults", kind: "message", T: ScoringCatalog },
    { no: 3, name: "is_workspace_override", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetActiveWeightsResponse {
    return new GetActiveWeightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetActiveWeightsResponse {
    return new GetActiveWeightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetActiveWeightsResponse {
    return new GetActiveWeightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetActiveWeightsResponse | PlainMessage<GetActiveWeightsResponse> | undefined, b: GetActiveWeightsResponse | PlainMessage<GetActiveWeightsResponse> | undefined): boolean {
    return proto3.util.equals(GetActiveWeightsResponse, a, b);
  }
}

/**
 * SaveWeightsRequest directly sets the active weight set for a scope (manual
 * admin tuning). workspace_id is honored ONLY for platform-admins (empty edits
 * the global default); tenant admins always edit their own workspace and the
 * field is ignored. The previous active set for the scope is archived.
 *
 * @generated from message tracker.v1.SaveWeightsRequest
 */
export class SaveWeightsRequest extends Message<SaveWeightsRequest> {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId = "";

  /**
   * @generated from field: tracker.v1.ScoringCatalog catalog = 2;
   */
  catalog?: ScoringCatalog;

  /**
   * @generated from field: string note = 3;
   */
  note = "";

  constructor(data?: PartialMessage<SaveWeightsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SaveWeightsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "catalog", kind: "message", T: ScoringCatalog },
    { no: 3, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaveWeightsRequest {
    return new SaveWeightsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaveWeightsRequest {
    return new SaveWeightsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaveWeightsRequest {
    return new SaveWeightsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SaveWeightsRequest | PlainMessage<SaveWeightsRequest> | undefined, b: SaveWeightsRequest | PlainMessage<SaveWeightsRequest> | undefined): boolean {
    return proto3.util.equals(SaveWeightsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SaveWeightsResponse
 */
export class SaveWeightsResponse extends Message<SaveWeightsResponse> {
  constructor(data?: PartialMessage<SaveWeightsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SaveWeightsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaveWeightsResponse {
    return new SaveWeightsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaveWeightsResponse {
    return new SaveWeightsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaveWeightsResponse {
    return new SaveWeightsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SaveWeightsResponse | PlainMessage<SaveWeightsResponse> | undefined, b: SaveWeightsResponse | PlainMessage<SaveWeightsResponse> | undefined): boolean {
    return proto3.util.equals(SaveWeightsResponse, a, b);
  }
}

